import { Injectable } from '@angular/core';

import { FileEntry } from '@ionic-native/file';
import { APP_CONFIG } from '../../app.config';
import { UtilHelper } from '../../shared/helpers/utils.helper';
import { RequestService } from '../../shared/services/request.service';
import { CustomersFilter } from './models/customer-filter.model';
import { CustomerInfo } from './models/customer-info.model';
import { Customer, CustomerResponse } from './models/customer.model';

@Injectable()
export class CustomerService {
  constructor(private requestService: RequestService) {}

  async getCustomers(storeId: number, filter: CustomersFilter): Promise<CustomerResponse> {
    let urlRequest: string = this.requestService.buildUrlPathParams(
      { storeId: storeId },
      APP_CONFIG.WEBSERVICE.CUSTOMERS
    );
    urlRequest += '?' + this.requestService.buildUrlParams(filter);
    let response: CustomerResponse = await this.requestService.getData(urlRequest);

    const customers: Array<Customer> = [];
    if (response && response.data && response.data.length > 0) {
      response.data.forEach((item) => {
        customers.push(new Customer(item));
      });
    }
    response.data = customers;
    return response;
  }

  async searchAutocompleteCustomers(
    storeId: number,
    filter: CustomersFilter,
    useCustomerServiceApi?: boolean
  ): Promise<CustomerInfo[]> {
    const api: string = useCustomerServiceApi
      ? APP_CONFIG.WEBSERVICE.SEARCH_CUSTOMER_SERVICES
      : APP_CONFIG.WEBSERVICE.SEARCH_CUSTOMER;
    let urlRequest: string = this.requestService.buildUrlPathParams({ storeId: storeId }, api);
    urlRequest += '?' + this.requestService.buildUrlParams(filter);
    let response: CustomerResponse = await this.requestService.getData(urlRequest);

    const customers: Array<CustomerInfo> = [];
    if (response && response.data && response.data.length > 0) {
      response.data.forEach((item) => {
        if (useCustomerServiceApi && item.customer) {
          customers.push(new CustomerInfo(item.customer));
        } else {
          customers.push(new CustomerInfo(item));
        }
      });
    }
    return customers;
  }

  async exportCustomers(storeId: number, filter: CustomersFilter): Promise<FileEntry> {
    let urlRequest: string = this.requestService.buildUrlPathParams(
      { storeId: storeId },
      APP_CONFIG.WEBSERVICE.EXPORT_CUSTOMERS
    );
    urlRequest += '?' + this.requestService.buildUrlParams(filter);

    this.requestService.addParamsHeader('Content-Type', 'application/octet-stream');
    let date = new Date().getTime();
    const filename: string = `fastget_clientes_${date}.csv`;
    return await this.requestService.downloadFile(urlRequest, filename);
  }

  async updateCustomerData(customer: CustomerInfo): Promise<void> {
    customer.cpf = UtilHelper.unmask(customer.cpf);
    customer.phone = UtilHelper.unmask(customer.phone);
    await this.requestService.putData(
      APP_CONFIG.WEBSERVICE.UPDATE_CUSTOMER,
      customer.toJsonUpdate()
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/customers/customers.service.ts